/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Sep 18 2023 00:00:00 PM
 *
 *******************************************************/
//flow

import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Notification from 'src/components/containers/dashboard/notifications/notification';

type Props = {
  subscription: Object,
  tenantApp: Object
};

type ComposedProps = Props & WithI18nProps;

const renderSpecialDiscountAddonExpiredSoon: React.FC<ComposedProps> = (
  subscription: Object,
  tenantApp: Object,
  code: string,
  i18n: Object
) => {
  const { dayLeft } = subscription;
  const { specialDiscountExpiredAt } = tenantApp;
  const expiredDate = moment(new Date(specialDiscountExpiredAt * 1000)).format('DD/MM/YYYY');

  if (dayLeft > 7) return;

  // Uppercase first character (fix for german text, since duration appears at the beginning of string)
  let duration = i18n.translate(`AdminHTML.Common.Duration.day`, {
    count: dayLeft,
    nt_number: i18n.formatNumber(dayLeft)
  });

  const contentHtml = (
    <div>
      <p>
        {i18n.translate('AdminHTML.Common.SpecialAddonDiscountExpiredSoonNotification.content', {
          date: expiredDate,
          price: 49
        })}
      </p>
    </div>
  );

  let notification = {
    type: 'warning',
    allowDismiss: false,
    title: i18n.translate(`AdminHTML.Common.SpecialAddonDiscountExpiredSoonNotification.title`, {
      t: i18n.translate(`AdminHTML.Common.SpecialAddonDiscountExpiredSoonNotification.title_t`, {
        t: duration
      }),
      code
    }),
    contentHtml,
    actionLabel: i18n.translate(
      'AdminHTML.Common.SpecialAddonDiscountExpiredSoonNotification.action'
    ),
    action: '/addon'
  };

  return (
    <div className="exceededPlanNotification">
      <Notification status={notification.type} notification={notification} />
    </div>
  );
};

const renderSpecialDiscountAddonExpired: React.FC<ComposedProps> = (code: string, i18n: Object) => {
  const contentHtml = (
    <div>
      <p>
        {i18n.translate('AdminHTML.Common.SpecialAddonDiscountExpiredNotification.content', {
          price: 49
        })}
      </p>
    </div>
  );

  let notification = {
    type: 'warning',
    allowDismiss: false,
    title: i18n.translate('AdminHTML.Common.SpecialAddonDiscountExpiredNotification.title', {
      t: i18n.translate('AdminHTML.Common.SpecialAddonDiscountExpiredNotification.title_t'),
      code
    }),
    contentHtml,
    actionLabel: i18n.translate('AdminHTML.Common.SpecialAddonDiscountExpiredNotification.action'),
    action: '/addon'
  };
  return (
    <div className="exceededPlanNotification">
      <Notification status={notification.type} notification={notification} />
    </div>
  );
};

const AddonSpecialDiscountBanner: React.FC<ComposedProps> = ({ subscription, tenantApp, i18n }) => {
  const { status, discountCode } = subscription;

  const code = _.get(discountCode, 'code', '');
  const codeDisplay = code.split('-')[0];
  let component = {
    specialDiscountExpiredSoon: renderSpecialDiscountAddonExpiredSoon(
      subscription,
      tenantApp,
      codeDisplay,
      i18n
    ),
    specialDiscountExpired: renderSpecialDiscountAddonExpired(codeDisplay, i18n)
  };

  return component[status] || null;
};

const mapStateToProps = state => ({
  subscription: _.get(state.oauth, 'subscription', {}),
  tenantApp: _.get(state.oauth, 'tenantApp', {})
});

export default connect(mapStateToProps)(withI18n()(AddonSpecialDiscountBanner));
